export interface IPipelineOutput {
    key: string;
    type: Type;
    content?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export enum Type {
    Null = 'Null',
    Int = 'Int',
    Float = 'Float',
    Boolean = 'Boolean', // eslint-disable-line id-blacklist
    String = 'String', // eslint-disable-line id-blacklist
    Expression = 'Expression',
    Object = 'Object',
    Array = 'Array',
}
